const DATE_FILTER_RANGE_SEPARATOR = ' - ';

const parseIsoDatePart = (part: string) => {
  const date = new Date(part.trim());
  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
};

const parseDateFilterValue = (rawValue: string) => {
  const trimmed = rawValue.trim();
  if (!trimmed) {
    return '';
  }

  if (trimmed.includes(DATE_FILTER_RANGE_SEPARATOR)) {
    const separatorIndex = trimmed.indexOf(DATE_FILTER_RANGE_SEPARATOR);
    const fromRaw = trimmed.slice(0, separatorIndex);
    const toRaw = trimmed.slice(separatorIndex + DATE_FILTER_RANGE_SEPARATOR.length);
    const from = parseIsoDatePart(fromRaw);
    const to = parseIsoDatePart(toRaw);

    if (!from || !to) {
      return '';
    }

    return `${from}${DATE_FILTER_RANGE_SEPARATOR}${to}`;
  }

  if (trimmed.includes(',')) {
    const parts = trimmed
      .split(',')
      .map((part) => parseIsoDatePart(part))
      .filter(Boolean);

    if (parts.length === 2) {
      const [from, to] = parts;
      if (from && to) {
        return `${from}${DATE_FILTER_RANGE_SEPARATOR}${to}`;
      }
    }
  }

  return parseIsoDatePart(trimmed);
};

const filterValueToUrlString = (value: unknown): string => {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  if (Array.isArray(value)) {
    const parts = value
      .filter((item) => item !== null && item !== undefined && item !== '')
      .map((item) => (item instanceof Date ? item.toISOString() : String(item).trim()))
      .filter(Boolean);

    if (parts.length === 2 && parts.every((part) => parseIsoDatePart(part))) {
      const from = parseIsoDatePart(parts[0] ?? '');
      const to = parseIsoDatePart(parts[1] ?? '');

      if (from && to) {
        return `${from}${DATE_FILTER_RANGE_SEPARATOR}${to}`;
      }
    }

    return parts.join(',');
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  return '';
};

const parseSelectFilterValue = (rawValue: string, allowed: ReadonlySet<string>) => {
  const trimmed = rawValue.trim();
  return allowed.has(trimmed) ? trimmed : '';
};

const parseMultiSelectFilterValue = (rawValue: string, allowed: ReadonlySet<string>) =>
  rawValue
    .split(',')
    .map((value) => value.trim())
    .filter((value) => allowed.has(value))
    .join(',');

const parseTextFilterValue = (rawValue: string) => rawValue.trim();

export {
  DATE_FILTER_RANGE_SEPARATOR,
  filterValueToUrlString,
  parseDateFilterValue,
  parseMultiSelectFilterValue,
  parseSelectFilterValue,
  parseTextFilterValue
};
